import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {DirecDown} from "../../../../../icons/DirecDown";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const MiddleYoungOnboardingCardId = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/sport-onboarding_phone-MIDDLEYOUNG-mobile${currentParams}`);
  };

  return (
      <div className="young-card-id">
        <div className="overlap-group-wrapper">
          <div className="overlap-2">
            <div className="overlap-group-4">

              <div className="frame-12">
                <div className="molecula-stepper">
                  <div className="content-4">
                    <div className="numb">
                      <div className="text-wrapper-9">1</div>
                    </div>

                    <div className="line" />
                  </div>

                  <div className="div-3">
                    <div className="div-3">
                      <div className="numb-2">
                        <div className="text-wrapper-10">2</div>
                      </div>

                      <div className="line-2" />
                    </div>
                  </div>

                  <div className="div-3">
                    <div className="div-3">
                      <div className="numb-3">
                        <div className="text-wrapper-11">3</div>
                      </div>

                      <div className="line-3" />
                    </div>
                  </div>

                  <div className="div-3">
                    <div className="div-3">
                      <div className="numb-3">
                        <div className="text-wrapper-11">4</div>
                      </div>

                      <div className="line-3" />
                    </div>
                  </div>

                  <div className="div-3">
                    <div className="div-3">
                      <div className="numb-3">
                        <div className="text-wrapper-11">5</div>
                      </div>

                      <div className="line-3" />
                    </div>
                  </div>

                  <div className="atomo-step-final-no">
                    <div className="content-5">
                      <div className="numb-3">
                        <div className="text-wrapper-11">6</div>
                      </div>
                    </div>
                  </div>
                </div>

                <img className="element-2" alt="Element" src="/img/iconidmyoung.png" />

                <div className="frame-13">
                  <p className="subtitle-5">Now, get your ID card</p>
                </div>

                <div className="element-3">
                  <p className="subtitle-6">
                    We will take a photo of the front &amp; back.
                    <br />
                    <br />
                    Center your document in the frame and please make sure it
                    doesn´t show any glare or shadows.
                    <br />
                    <br />
                    Photos will be captured automatically.
                  </p>

                  <div className="frame-14">
                    <div className="text-wrapper-12">Country</div>

                    <div className="account-select">
                      <div className="frame-15">
                        <div className="frame-16">
                          <div className="text-wrapper-13">USA</div>
                        </div>

                        <DirecDown
                            className="btn-icon-chevron"
                            color={colors.primario}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ marginTop: 150, width: "100%" }}>
                    <div
                        className="frame-17 highlighted-button"
                        style={{ borderRadius: 12, width: "100%" }}
                        onClick={handleButtonClick}
                    >
                      <p className="text-wrapper-14">I´ve got my ID card!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-18">
              <div className="bars-status-default-wrapper"></div>

              <div className="panel-panel-primary-2">
                <div className="title-2">Scan ID Card</div>

                <img
                    className="icons-arrow-back-2"
                    alt="Icons arrow back"
                    src="/img/icons-arrow-back-1.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
